// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3ocRS","description":"PatientConsentPreview_description__1jKv3"};